import React, { Fragment } from "react"
// import ScrollAnimation from 'react-animate-on-scroll'
import { Link } from "react-static"

const Masthead = () => {
	return(
		<Fragment>
    <section className="Masthead">
      <div className="container">
        <div className="row center-xs">
          <div className="col-xs-10 Hero">
            <div className="box">
              <h1 className="slide-right">We create unique things for your visual needs!</h1>
              <h2 className="slide-left">
                Discover what good design and practical sense makes for a better user experience.
              </h2>
              <div className="button-wrap slide-up">
                <Link to="/getting-started" className="getting-started">
                  <i className="fa fa-thumbs-up" aria-hidden="true" />start your
                  project today!
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Fragment>
	)
}
export default Masthead



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Home/components/masthead.js